import React from 'react'
import { ComposableMap, Geographies, Geography } from 'react-simple-maps'

// GeoJSON source for world map
const geoUrl =
  'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json'

// Country codes to highlight
const highlightColors = {
  USA: '#4ade80',
  Canada: '#facc15',
  UK: '#38bdf8',
  India: '#a78bfa',
  Australia: '#fb7185',
}

const countryNameMap = {
  USA: 'United States of America',
  UK: 'United Kingdom',
  India: 'India',
  Canada: 'Canada',
  Australia: 'Australia',
}

const TopRegion = ({ data }) => {
  // Count frequencies
  const countMap = {}
  data.forEach((row) => {
    const region = row.Region?.trim()
    if (region) {
      countMap[region] = (countMap[region] || 0) + 1
    }
  })

  const total = Object.values(countMap).reduce((sum, v) => sum + v, 0)
  const topRegions = Object.keys(highlightColors)
    .map((region) => ({
      region,
      percent: total ? ((countMap[region] || 0) / total * 100).toFixed(0) : 0,
    }))
    .sort((a, b) => b.percent - a.percent)

  return (
    <div className="bg-white rounded shadow p-4 w-full">
      <h2 className="font-semibold text-sm text-gray-700 mb-4">TOP REGIONS</h2>
      <div className="flex flex-col lg:flex-row">
        {/* Map */}
        <div className="w-full lg:w-2/3">
          <ComposableMap projectionConfig={{ scale: 130 }}>
            <Geographies geography={geoUrl}>
              {({ geographies }) =>
                geographies.map((geo) => {
                  const name = geo.properties.NAME
                  const matchedKey = Object.keys(countryNameMap).find(
                    (key) => countryNameMap[key] === name
                  )
                  const color = matchedKey ? highlightColors[matchedKey] : '#e5e7eb'

                  return (
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      fill={color}
                      stroke="#fff"
                      strokeWidth={0.3}
                    />
                  )
                })
              }
            </Geographies>
          </ComposableMap>
        </div>

        {/* Legend */}
        <div className="w-full lg:w-1/3 mt-4 lg:mt-0 lg:pl-6">
          <ul className="text-sm space-y-2">
            {topRegions.map(({ region, percent }) => (
              <li key={region} className="flex items-center justify-between">
                <span className="flex items-center">
                  <span
                    className="inline-block w-3 h-3 rounded-full mr-2"
                    style={{ backgroundColor: highlightColors[region] }}
                  ></span>
                  {region}
                </span>
                <span className="font-semibold">{percent}%</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default TopRegion
